import React from 'react';
import { Link } from 'react-router';

import { getCountryName } from '../helpers/countryNames';
import CountryAssistance from '../components/CountryAssistance';

export default class AssistanceCountryPage extends React.Component {
  render() {
    const countryName = getCountryName(this.props.params.id);
    const hash = this.props.location.hash;

    return (
      <div style={{ marginTop: '-25px' }}>
        {' '}
        {/* hack to make breadcrump align with gray outer area... */}
        <ol className="breadcrumb">
          <li>
            <Link activeClassName="active" to="/international-assistance">
              International assistance
            </Link>
          </li>
          <li className="active">{countryName}</li>
        </ol>
        <CountryAssistance
          countryCode={ this.props.params.id }
          countryName={ countryName }
          anchorTo={ hash }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AssistanceCountry.js